// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getOrder = /* GraphQL */ `query GetOrder($id: ID!) {
  getOrder(id: $id) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    stripeCustomerId
    invoiceNumber
    invoiceId
    receiptNumber
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    email
    status
    cost_total
    cost_taxes
    cost_shipping
    couponId
    coupon_amount_off
    coupon_name
    discountId
    discount_amount
    promotionID
    promotion_code
    fulfillment_tracking_id
    fulfillment_method
    fulfillment_status
    fulfillment_createdAt
    fulfillment_updatedAt
    fulfillment_completedAt
    billing_name
    billing_address
    billing_address2
    billing_city
    billing_state
    billing_zip
    billing_country
    shipping_name
    shipping_address
    shipping_address2
    shipping_city
    shipping_state
    shipping_zip
    shipping_country
    shipping_phone
    notes
    vendor
    order_source
    currency
    cancel
    updatedAt
    userOrdersId
    orderCartId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetOrderQueryVariables, APITypes.GetOrderQuery>;
export const listOrders = /* GraphQL */ `query ListOrders(
  $filter: ModelOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrdersQueryVariables,
  APITypes.ListOrdersQuery
>;
export const ordersByInvoiceNumber = /* GraphQL */ `query OrdersByInvoiceNumber(
  $invoiceNumber: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  ordersByInvoiceNumber(
    invoiceNumber: $invoiceNumber
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrdersByInvoiceNumberQueryVariables,
  APITypes.OrdersByInvoiceNumberQuery
>;
export const ordersByInvoiceId = /* GraphQL */ `query OrdersByInvoiceId(
  $invoiceId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  ordersByInvoiceId(
    invoiceId: $invoiceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrdersByInvoiceIdQueryVariables,
  APITypes.OrdersByInvoiceIdQuery
>;
export const ordersByEmailAndCreatedAt = /* GraphQL */ `query OrdersByEmailAndCreatedAt(
  $email: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  ordersByEmailAndCreatedAt(
    email: $email
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrdersByEmailAndCreatedAtQueryVariables,
  APITypes.OrdersByEmailAndCreatedAtQuery
>;
export const getCart = /* GraphQL */ `query GetCart($id: ID!) {
  getCart(id: $id) {
    id
    createdAt
    order {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      stripeCustomerId
      invoiceNumber
      invoiceId
      receiptNumber
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      email
      status
      cost_total
      cost_taxes
      cost_shipping
      couponId
      coupon_amount_off
      coupon_name
      discountId
      discount_amount
      promotionID
      promotion_code
      fulfillment_tracking_id
      fulfillment_method
      fulfillment_status
      fulfillment_createdAt
      fulfillment_updatedAt
      fulfillment_completedAt
      billing_name
      billing_address
      billing_address2
      billing_city
      billing_state
      billing_zip
      billing_country
      shipping_name
      shipping_address
      shipping_address2
      shipping_city
      shipping_state
      shipping_zip
      shipping_country
      shipping_phone
      notes
      vendor
      order_source
      currency
      cancel
      updatedAt
      userOrdersId
      orderCartId
      __typename
    }
    artOrders {
      items {
        id
        createdAt
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        orderID
        art {
          id
          userId
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          title
          inputImage
          s3Image {
            bucket
            region
            key
            __typename
          }
          prompt
          revisedPrompt
          subject
          subjectText
          subOption
          styles
          stylesText
          color
          colorText
          medium
          mediumText
          model
          feeling
          feelingText
          like
          approve
          deleted
          updatedAt
          __typename
        }
        email
        file {
          bucket
          region
          key
          __typename
        }
        dpi
        length
        width
        resolution_length
        resolution_width
        paper
        frame
        moulding
        moulding_finish
        mount
        total
        tax
        updatedAt
        cartArtOrdersId
        artOrderArtId
        __typename
      }
      nextToken
      __typename
    }
    email
    status
    cost_total
    updatedAt
    cartOrderId
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCartQueryVariables, APITypes.GetCartQuery>;
export const listCarts = /* GraphQL */ `query ListCarts(
  $filter: ModelCartFilterInput
  $limit: Int
  $nextToken: String
) {
  listCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListCartsQueryVariables, APITypes.ListCartsQuery>;
export const cartsByEmailAndCreatedAt = /* GraphQL */ `query CartsByEmailAndCreatedAt(
  $email: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCartFilterInput
  $limit: Int
  $nextToken: String
) {
  cartsByEmailAndCreatedAt(
    email: $email
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CartsByEmailAndCreatedAtQueryVariables,
  APITypes.CartsByEmailAndCreatedAtQuery
>;
export const getArtOrder = /* GraphQL */ `query GetArtOrder($id: ID!) {
  getArtOrder(id: $id) {
    id
    createdAt
    cart {
      id
      createdAt
      order {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      artOrders {
        items {
          id
          createdAt
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          orderID
          art {
            id
            userId
            createdAt
            title
            inputImage
            prompt
            revisedPrompt
            subject
            subjectText
            subOption
            styles
            stylesText
            color
            colorText
            medium
            mediumText
            model
            feeling
            feelingText
            like
            approve
            deleted
            updatedAt
            __typename
          }
          email
          file {
            bucket
            region
            key
            __typename
          }
          dpi
          length
          width
          resolution_length
          resolution_width
          paper
          frame
          moulding
          moulding_finish
          mount
          total
          tax
          updatedAt
          cartArtOrdersId
          artOrderArtId
          __typename
        }
        nextToken
        __typename
      }
      email
      status
      cost_total
      updatedAt
      cartOrderId
      __typename
    }
    orderID
    art {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    email
    file {
      bucket
      region
      key
      __typename
    }
    dpi
    length
    width
    resolution_length
    resolution_width
    paper
    frame
    moulding
    moulding_finish
    mount
    total
    tax
    updatedAt
    cartArtOrdersId
    artOrderArtId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetArtOrderQueryVariables,
  APITypes.GetArtOrderQuery
>;
export const listArtOrders = /* GraphQL */ `query ListArtOrders(
  $filter: ModelArtOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listArtOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      orderID
      art {
        id
        userId
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        title
        inputImage
        s3Image {
          bucket
          region
          key
          __typename
        }
        prompt
        revisedPrompt
        subject
        subjectText
        subOption
        styles
        stylesText
        color
        colorText
        medium
        mediumText
        model
        feeling
        feelingText
        like
        approve
        deleted
        updatedAt
        __typename
      }
      email
      file {
        bucket
        region
        key
        __typename
      }
      dpi
      length
      width
      resolution_length
      resolution_width
      paper
      frame
      moulding
      moulding_finish
      mount
      total
      tax
      updatedAt
      cartArtOrdersId
      artOrderArtId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArtOrdersQueryVariables,
  APITypes.ListArtOrdersQuery
>;
export const artOrdersByEmailAndCreatedAt = /* GraphQL */ `query ArtOrdersByEmailAndCreatedAt(
  $email: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelartOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  artOrdersByEmailAndCreatedAt(
    email: $email
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      cart {
        id
        createdAt
        order {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        artOrders {
          items {
            id
            createdAt
            orderID
            email
            dpi
            length
            width
            resolution_length
            resolution_width
            paper
            frame
            moulding
            moulding_finish
            mount
            total
            tax
            updatedAt
            cartArtOrdersId
            artOrderArtId
            __typename
          }
          nextToken
          __typename
        }
        email
        status
        cost_total
        updatedAt
        cartOrderId
        __typename
      }
      orderID
      art {
        id
        userId
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        title
        inputImage
        s3Image {
          bucket
          region
          key
          __typename
        }
        prompt
        revisedPrompt
        subject
        subjectText
        subOption
        styles
        stylesText
        color
        colorText
        medium
        mediumText
        model
        feeling
        feelingText
        like
        approve
        deleted
        updatedAt
        __typename
      }
      email
      file {
        bucket
        region
        key
        __typename
      }
      dpi
      length
      width
      resolution_length
      resolution_width
      paper
      frame
      moulding
      moulding_finish
      mount
      total
      tax
      updatedAt
      cartArtOrdersId
      artOrderArtId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtOrdersByEmailAndCreatedAtQueryVariables,
  APITypes.ArtOrdersByEmailAndCreatedAtQuery
>;
export const getArt = /* GraphQL */ `query GetArt($id: ID!) {
  getArt(id: $id) {
    id
    userId
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    title
    inputImage
    s3Image {
      bucket
      region
      key
      __typename
    }
    prompt
    revisedPrompt
    subject
    subjectText
    subOption
    styles
    stylesText
    color
    colorText
    medium
    mediumText
    model
    feeling
    feelingText
    like
    approve
    deleted
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetArtQueryVariables, APITypes.GetArtQuery>;
export const listArts = /* GraphQL */ `query ListArts($filter: ModelArtFilterInput, $limit: Int, $nextToken: String) {
  listArts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListArtsQueryVariables, APITypes.ListArtsQuery>;
export const artsByUserIdAndCreatedAt = /* GraphQL */ `query ArtsByUserIdAndCreatedAt(
  $userId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelArtFilterInput
  $limit: Int
  $nextToken: String
) {
  artsByUserIdAndCreatedAt(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      title
      inputImage
      s3Image {
        bucket
        region
        key
        __typename
      }
      prompt
      revisedPrompt
      subject
      subjectText
      subOption
      styles
      stylesText
      color
      colorText
      medium
      mediumText
      model
      feeling
      feelingText
      like
      approve
      deleted
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtsByUserIdAndCreatedAtQueryVariables,
  APITypes.ArtsByUserIdAndCreatedAtQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    username
    emailVerified
    identityId
    credits
    boughtCredits
    creditPurchases {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        creditAmount
        checkoutSessionId
        paymentIntentId
        owner
        updatedAt
        userCreditPurchasesId
        __typename
      }
      nextToken
      __typename
    }
    orders {
      items {
        id
        createdAt
        user {
          id
          email
          username
          emailVerified
          identityId
          credits
          boughtCredits
          creditPurchases {
            nextToken
            __typename
          }
          orders {
            nextToken
            __typename
          }
          stripeCustomerId
          owner
          createdAt
          updatedAt
          __typename
        }
        stripeCustomerId
        invoiceNumber
        invoiceId
        receiptNumber
        cart {
          id
          createdAt
          order {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          artOrders {
            nextToken
            __typename
          }
          email
          status
          cost_total
          updatedAt
          cartOrderId
          __typename
        }
        email
        status
        cost_total
        cost_taxes
        cost_shipping
        couponId
        coupon_amount_off
        coupon_name
        discountId
        discount_amount
        promotionID
        promotion_code
        fulfillment_tracking_id
        fulfillment_method
        fulfillment_status
        fulfillment_createdAt
        fulfillment_updatedAt
        fulfillment_completedAt
        billing_name
        billing_address
        billing_address2
        billing_city
        billing_state
        billing_zip
        billing_country
        shipping_name
        shipping_address
        shipping_address2
        shipping_city
        shipping_state
        shipping_zip
        shipping_country
        shipping_phone
        notes
        vendor
        order_source
        currency
        cancel
        updatedAt
        userOrdersId
        orderCartId
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const usersByEmail = /* GraphQL */ `query UsersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;
export const getSession = /* GraphQL */ `query GetSession($id: ID!) {
  getSession(id: $id) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    credentials {
      AccessKeyId
      Expiration
      SecretKey
      __typename
    }
    owner
    updatedAt
    sessionUserId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSessionQueryVariables,
  APITypes.GetSessionQuery
>;
export const listSessions = /* GraphQL */ `query ListSessions(
  $filter: ModelSessionFilterInput
  $limit: Int
  $nextToken: String
) {
  listSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      credentials {
        AccessKeyId
        Expiration
        SecretKey
        __typename
      }
      owner
      updatedAt
      sessionUserId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSessionsQueryVariables,
  APITypes.ListSessionsQuery
>;
export const getCreditPurchase = /* GraphQL */ `query GetCreditPurchase($id: ID!) {
  getCreditPurchase(id: $id) {
    id
    createdAt
    user {
      id
      email
      username
      emailVerified
      identityId
      credits
      boughtCredits
      creditPurchases {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          creditAmount
          checkoutSessionId
          paymentIntentId
          owner
          updatedAt
          userCreditPurchasesId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          createdAt
          user {
            id
            email
            username
            emailVerified
            identityId
            credits
            boughtCredits
            stripeCustomerId
            owner
            createdAt
            updatedAt
            __typename
          }
          stripeCustomerId
          invoiceNumber
          invoiceId
          receiptNumber
          cart {
            id
            createdAt
            email
            status
            cost_total
            updatedAt
            cartOrderId
            __typename
          }
          email
          status
          cost_total
          cost_taxes
          cost_shipping
          couponId
          coupon_amount_off
          coupon_name
          discountId
          discount_amount
          promotionID
          promotion_code
          fulfillment_tracking_id
          fulfillment_method
          fulfillment_status
          fulfillment_createdAt
          fulfillment_updatedAt
          fulfillment_completedAt
          billing_name
          billing_address
          billing_address2
          billing_city
          billing_state
          billing_zip
          billing_country
          shipping_name
          shipping_address
          shipping_address2
          shipping_city
          shipping_state
          shipping_zip
          shipping_country
          shipping_phone
          notes
          vendor
          order_source
          currency
          cancel
          updatedAt
          userOrdersId
          orderCartId
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      owner
      createdAt
      updatedAt
      __typename
    }
    creditAmount
    checkoutSessionId
    paymentIntentId
    owner
    updatedAt
    userCreditPurchasesId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCreditPurchaseQueryVariables,
  APITypes.GetCreditPurchaseQuery
>;
export const listCreditPurchases = /* GraphQL */ `query ListCreditPurchases(
  $filter: ModelCreditPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listCreditPurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      creditAmount
      checkoutSessionId
      paymentIntentId
      owner
      updatedAt
      userCreditPurchasesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCreditPurchasesQueryVariables,
  APITypes.ListCreditPurchasesQuery
>;
export const creditPurchasesByCheckoutSessionId = /* GraphQL */ `query CreditPurchasesByCheckoutSessionId(
  $checkoutSessionId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelCreditPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  creditPurchasesByCheckoutSessionId(
    checkoutSessionId: $checkoutSessionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      user {
        id
        email
        username
        emailVerified
        identityId
        credits
        boughtCredits
        creditPurchases {
          items {
            id
            createdAt
            creditAmount
            checkoutSessionId
            paymentIntentId
            owner
            updatedAt
            userCreditPurchasesId
            __typename
          }
          nextToken
          __typename
        }
        orders {
          items {
            id
            createdAt
            stripeCustomerId
            invoiceNumber
            invoiceId
            receiptNumber
            email
            status
            cost_total
            cost_taxes
            cost_shipping
            couponId
            coupon_amount_off
            coupon_name
            discountId
            discount_amount
            promotionID
            promotion_code
            fulfillment_tracking_id
            fulfillment_method
            fulfillment_status
            fulfillment_createdAt
            fulfillment_updatedAt
            fulfillment_completedAt
            billing_name
            billing_address
            billing_address2
            billing_city
            billing_state
            billing_zip
            billing_country
            shipping_name
            shipping_address
            shipping_address2
            shipping_city
            shipping_state
            shipping_zip
            shipping_country
            shipping_phone
            notes
            vendor
            order_source
            currency
            cancel
            updatedAt
            userOrdersId
            orderCartId
            __typename
          }
          nextToken
          __typename
        }
        stripeCustomerId
        owner
        createdAt
        updatedAt
        __typename
      }
      creditAmount
      checkoutSessionId
      paymentIntentId
      owner
      updatedAt
      userCreditPurchasesId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CreditPurchasesByCheckoutSessionIdQueryVariables,
  APITypes.CreditPurchasesByCheckoutSessionIdQuery
>;
export const getGiftCardPurchase = /* GraphQL */ `query GetGiftCardPurchase($id: ID!) {
  getGiftCardPurchase(id: $id) {
    id
    createdAt
    originalBalance
    couponId
    couponAmountOff
    couponCurrency
    couponName
    couponDuration
    couponMaxRedemptions
    promotionCode
    promotionID
    checkoutSessionId
    paymentIntentId
    recipientEmail
    customMessage
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGiftCardPurchaseQueryVariables,
  APITypes.GetGiftCardPurchaseQuery
>;
export const listGiftCardPurchases = /* GraphQL */ `query ListGiftCardPurchases(
  $filter: ModelGiftCardPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listGiftCardPurchases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      originalBalance
      couponId
      couponAmountOff
      couponCurrency
      couponName
      couponDuration
      couponMaxRedemptions
      promotionCode
      promotionID
      checkoutSessionId
      paymentIntentId
      recipientEmail
      customMessage
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGiftCardPurchasesQueryVariables,
  APITypes.ListGiftCardPurchasesQuery
>;
export const giftCardPurchasesByCheckoutSessionId = /* GraphQL */ `query GiftCardPurchasesByCheckoutSessionId(
  $checkoutSessionId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelGiftCardPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  giftCardPurchasesByCheckoutSessionId(
    checkoutSessionId: $checkoutSessionId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      originalBalance
      couponId
      couponAmountOff
      couponCurrency
      couponName
      couponDuration
      couponMaxRedemptions
      promotionCode
      promotionID
      checkoutSessionId
      paymentIntentId
      recipientEmail
      customMessage
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GiftCardPurchasesByCheckoutSessionIdQueryVariables,
  APITypes.GiftCardPurchasesByCheckoutSessionIdQuery
>;
export const giftCardPurchasesByRecipientEmail = /* GraphQL */ `query GiftCardPurchasesByRecipientEmail(
  $recipientEmail: String!
  $sortDirection: ModelSortDirection
  $filter: ModelGiftCardPurchaseFilterInput
  $limit: Int
  $nextToken: String
) {
  giftCardPurchasesByRecipientEmail(
    recipientEmail: $recipientEmail
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      createdAt
      originalBalance
      couponId
      couponAmountOff
      couponCurrency
      couponName
      couponDuration
      couponMaxRedemptions
      promotionCode
      promotionID
      checkoutSessionId
      paymentIntentId
      recipientEmail
      customMessage
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GiftCardPurchasesByRecipientEmailQueryVariables,
  APITypes.GiftCardPurchasesByRecipientEmailQuery
>;
